import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_time_zone_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { country?: string, fullTextSearch?: string, countrySelector?: boolean, $top?: number, $skip?: number }): Promise<{ result?: { country?: string, UTC?: string, time_zone?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_time_zone_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { country?: string, fullTextSearch?: string, countrySelector?: boolean, $keys: { country?: string, UTC?: string, time_zone?: string }[] }): Promise<{ result?: { country?: string, UTC?: string, time_zone?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_time_zone_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      country?: string, fullTextSearch?: string, countrySelector?: boolean    }) {
      return false;
    }
}
